import { Enum_LiveStream_Status } from '@core/api';
import { EnumVideoWrapperType } from './types';
function isReplay(video) {
    return (video.live_stream_status === Enum_LiveStream_Status.REPLAY &&
        !!video.live_stream_replay_enabled &&
        !!video.live_stream_replay_url);
}
function isLive(video) {
    return ((video.live_stream_status === Enum_LiveStream_Status.ACTIVE ||
        video.live_stream_status === Enum_LiveStream_Status.PAUSED) &&
        !!video.live_stream_playback_url);
}
export function shouldUseIvsWrapper(video) {
    return (video.video_type === 'live_stream' && (isReplay(video) || isLive(video)));
}
export function isIVS(wrapper) {
    return wrapper.type === EnumVideoWrapperType.IVS;
}
export function isVideo(wrapper) {
    return wrapper.type === EnumVideoWrapperType.VIDEO;
}
export function isVideoWrapper(wrapper) {
    return !!(wrapper === null || wrapper === void 0 ? void 0 : wrapper.type);
}
